import AcceptInvitation from './accept-invitation';
export default AcceptInvitation;
